import { Filters, SimpleEnumType } from '@/types';
import { PollsStatuses } from '@/enums';

export namespace Polls {
  export enum Pages {
    POLL = 'poll',
  }

  export interface Poll {
    [key: string]: unknown,
    title: string | null,
    user_poll_id: number | null,
    published_at: string | null,
    expired_time: string | null,
    description: string | null,
    poll_id: number | null,
    status: SimpleEnumType<PollsStatuses>,
    link_page: {
      name: string,
      slug: string
    }
  }

  export interface Question {
    can_your_answer: boolean,
    type_question: {
      name: string,
      slug: string
    }
    group_id: number,
    id: number,
    title: string,
    description: string,
    is_required: boolean,
    type_answer: {
      name: string,
      slug: string,
    },
    type_answer_select: {
      name: string,
      slug: string,
    },
    question_grid_list: {
      cols: {
        answer: string,
        id: number,
      }[],
      rows: {
        answer: string,
        id: number,
      }[],
    },
    question_files: {
      answer: string,
      file_id: string,
      path: string,
    }[],
    question_answers: {
      answer: string | null,
      id: number,
      label_from: string | null,
      label_to: string | null,
      value_from: number,
      value_to: number,
    }[],
    user_answers: {
      answers: {
        [x: string]: {
          [x: string]: any; answer: string; id: number;
        };
      },
      grid_list: [
        {row_id: number, col_id: number}
      ],
      files: [
        {
          poll_question_file_id: number,
          answer: string
        }
      ]
    }
  }

  export interface Section {
    step_type: {
      id: number,
      name: string
      type: {
        id: number,
        name: string,
        slug: string,
      }
    },
    questions: Question[],
  }

  export interface Answers {
    is_required: boolean;
    id?: number;
    answers?: {
      answer?: any,
      id?: number
    }[]
    grid_list?: {
      col_id?: number;
      row_id?: number;
    }[];
    files?: {
      file_id?: number,
      poll_question_file_id?: number,
    }[],
  }

  export interface CurrentPoll {
    id: string | null,
    link_page: {
      id: number | null,
      name: string | null,
      slug: string | null
    }
    preview_text: string | null,
    sections: Section[],
    status: {
      id: number | null,
      name: string | null,
      slug: string | null
    },
    title: string | null,
    type: {
      id: number,
      name: string,
      slug: string
    }
  }
}

export interface PollsFilters extends Filters {
  [key: string]: unknown,
}
export interface Payload {
  questions: Polls.Answers[];
}
